import React, { useState } from 'react';
import cc from 'classcat';
import { Text } from '../../Text';
import { Button } from '../../Button';
import styles from './cancellationandreturn.module.sass';

export const CancellationAndReturn = ({
  policy_details,
  cabin_cancellation,
}) => {
  const filteredPolicyDetails =
    policy_details?.filter(i => i[0] !== '' || i[1] !== '') ?? '';
  const [isOpenDescription, setIsOpenDescription] = useState(false);
  return (
    <section className={styles.section}>
      <Text component="h2" variant="heading-4">
        Правила отмены и возврата
      </Text>
      <p className={styles.subdesc}>
        Количество дней до круиза - процент удержания от стоимости
      </p>
      <div
        className={cc([
          styles.ReturnDesc,
          { [styles.open]: isOpenDescription },
        ])}
      >
        <ul className={styles.list}>
          {Object.values(filteredPolicyDetails).map((AllRule, key) => (
            <div>
              <p>{AllRule.title !== null && AllRule.title}</p>
              {AllRule.table !== null &&
                AllRule.table.map(rule => (
                  <li key={key} className={styles.listItem}>
                    {rule[0]} - {rule[1]}
                  </li>
                ))}
            </div>
          ))}
        </ul>
        <div>
          <Text variant="heading-7">{cabin_cancellation?.title}</Text>
          <ul className={styles.list}>
            {cabin_cancellation?.title &&
              cabin_cancellation?.body?.map((rule, key) => (
                <li key={key} className={styles.listItem}>
                  {rule}
                </li>
              ))}
          </ul>
        </div>
      </div>
      <Button
        size="sm"
        onClick={() => setIsOpenDescription(!isOpenDescription)}
      >
        {isOpenDescription ? 'Скрыть' : 'Все'} правила
      </Button>
    </section>
  );
};
